import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GL_API } from "./apiRoutes";
interface UseGetDistributionGroupGLProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getDistributionGroupGL = async (communityId: string) =>
  await axiosAuth.get(`${GL_API}/community/${communityId}/group-distribution`);

const useGetDistributionGroupGL = ({
  queryParams,
  communityId,
}: UseGetDistributionGroupGLProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["distribution-gl-list", communityId],
    queryFn: () => getDistributionGroupGL(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetDistributionGroupGL;
